import React from 'react';

function GraduationCap() {
  /* eslint-disable max-len */
  return (
    <svg viewBox="0 0 24 24">
      <path d="M18.48 11.375l.187 3.292c.027.479-.257.923-.855 1.333-.597.41-1.413.734-2.447.974-1.035.24-2.157.36-3.365.36-1.208 0-2.33-.12-3.365-.36-1.034-.24-1.85-.564-2.447-.974-.598-.41-.882-.854-.855-1.333l.188-3.292L11.5 13.26c.153.049.32.073.5.073s.347-.024.5-.073l5.98-1.885zM24 8c0 .16-.076.267-.23.323L12.105 11.99c-.028.007-.062.01-.104.01-.042 0-.076-.003-.104-.01L5.104 9.844c-.298.236-.545.623-.74 1.161-.194.538-.312 1.158-.354 1.86.438.25.657.628.657 1.135 0 .48-.202.85-.604 1.115l.604 4.51c.014.097-.014.184-.084.26-.062.077-.146.115-.25.115h-2c-.104 0-.187-.038-.25-.115-.07-.076-.097-.163-.083-.26l.604-4.51C2.201 14.85 2 14.479 2 14c0-.507.226-.892.677-1.156.076-1.438.417-2.584 1.02-3.438L.23 8.323C.076 8.267 0 8.16 0 8s.076-.267.23-.323L11.895 4.01c.028-.007.062-.01.104-.01.042 0 .076.003.104.01l11.667 3.667c.153.056.229.163.229.323z" />
    </svg>
  );
  /* eslint-enable */
}

export default GraduationCap;



// WEBPACK FOOTER //
// ./src/common/icons/GraduationCap.js